import { message } from "antd";
import { useState } from "react";
import { api } from "../../../api";
import { Button } from "../../../externalComponents/tailwind/button";

export default function StopRegisteredBatchDialog({
  isOpen,
  onClose,
  batchToStop,
  user,
  onSuccess,
  onStoppedRefresh,
}) {
  const [stopping, setStopping] = useState(false);

  const handleConfirmStop = async () => {
    if (!batchToStop) {
      return;
    }

    setStopping(true);
    try {
      await api.stopProcessingCampaign({
        customerId: user.customerId,
        campaignId: batchToStop.campaignId,
        sendingBatchId: batchToStop.sendingBatchId,
      });

      message.success("Campaign stopped successfully!");
      onSuccess();
      if (onStoppedRefresh) {
        await onStoppedRefresh();
      }
      onClose();
    } catch (error) {
      console.error("Error stopping campaign:", error);
      message.error("Failed to stop campaign. Please try again.");
    } finally {
      setStopping(false);
    }
  };

  if (!isOpen || !batchToStop) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-lg mx-4">
        <h3 className="text-lg font-bold mb-4">Stop Campaign</h3>
        <p className="text-gray-700 mb-3">
          Are you sure you want to stop this campaign?
        </p>
        <div className="bg-gray-50 rounded-lg p-4 mb-4">
          <p className="font-semibold text-sm text-gray-900 mb-2">
            Campaign details:
          </p>
          <ul className="space-y-1 text-sm text-gray-700">
            <li>
              <strong>Campaign:</strong> {batchToStop.campaignName}
            </li>
            <li>
              <strong>Recipients:</strong> {batchToStop.totalContacts}
            </li>
          </ul>
        </div>
        <div className="bg-red-50 rounded-lg p-4 mb-6 border border-red-200">
          <p className="font-semibold text-sm text-red-900 mb-2">
            Impact of stopping:
          </p>
          <ul className="space-y-2 text-sm text-red-800">
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>
                All <strong>scheduled messages</strong> for this batch will be
                stopped immediately
              </span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>
                The campaign status will change to <strong>"stopped"</strong>
              </span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>
                You can resume this campaign later from the "Stopped campaigns"
                section
              </span>
            </li>
          </ul>
        </div>
        <div className="flex justify-end gap-3">
          <Button color="secondaryButton" onClick={onClose} disabled={stopping}>
            Cancel
          </Button>
          <Button color="red" onClick={handleConfirmStop} disabled={stopping}>
            {stopping ? "Stopping..." : "Stop Campaign"}
          </Button>
        </div>
      </div>
    </div>
  );
}
